import { subscribe } from 'shared/store'
import { actionNames } from 'shared/store/ducks/userSession'
import floatingLabel from 'views/assets/scripts/floatingLabel'
import formControlValidation from 'views/assets/scripts/formValidation/formControlValidation'

const loadForgotPassword = async () => {
  floatingLabel()
  formControlValidation()

  if (window?.dataLayer) {
    window.dataLayer.push({ 'event': 'forgotPassword' })
  }
}

export default async () => {
  subscribe.after.once(actionNames.setUserSession, loadForgotPassword)
}
